import { lazyComponents } from './lazyComponentMap';

/** @param {string} lazyComponentPath */
export function importLazyComponent(lazyComponentPath) {
    // The map is generated from the files on disk (scripts/generate-import-maps.mjs) because the
    // path is only known at runtime. An unknown path rejects with webpack's own wording, which is
    // what the error boundary above loadComponent() has always reported.
    const load =
        lazyComponents[lazyComponentPath] ??
        (() => Promise.reject(new Error(`Cannot find module './${lazyComponentPath}.lazy'`)));

    return load();
}
